import React from 'react';
import PropType from 'prop-types';

// images
import styled from 'styled-components';
import { navigate } from '@reach/router';
import Facebook from '../../../assets/images/footer/fb.png';
import LinkedIn from '../../../assets/images/footer/linkedin.png';
import Instagram from '../../../assets/images/footer/insta.png';

// Atoms
import { SocialMediaIconWrapper } from '../../Atoms/Wrappers';
import { SocialMedia } from '../../Atoms/Images';
import {
	FooterBeforeFooterTitle, FooterContentWrapper, FooterCopyright, FooterFirstFooter, FooterFontAwesome,
	FooterLink, FooterSecondFooter, FooterSocialMediaLinkWrapper, FooterTitle, FooterWrapper,
} from './Footer.atoms';
import { Flex } from '../../Atoms/Flex-Grid';

const Logo = styled.h3`
	font-size: 25px;
    font-weight: bold;
    letter-spacing: 1.8px;
    cursor:pointer;
`;
const Footer = (props) => {
	const { links } = props;

	const renderFooterLinks = linksToRender => linksToRender.map(linkCategory => (
		<FooterContentWrapper key={linkCategory.title}>
			<FooterTitle>
				{linkCategory.title}
			</FooterTitle>
			{linkCategory.links.map((link) => {
				if (link.to) {
					return (
						<FooterLink
							to={link.to}
							key={link.name}
							green={link.green ? 'true' : null}
							duration={0.4}
						>
							{link.icon && <FooterFontAwesome icon={link.icon} />}
							{link.name}
						</FooterLink>
					);
				}
				if (link.href) {
					return (
						<FooterLink.External href={link.href} key={link.name} green={link.green}>
							{link.icon && <FooterFontAwesome icon={link.icon} />}
							{link.name}
						</FooterLink.External>
					);
				}
				return null;
			})}
		</FooterContentWrapper>
	));

	return (
		<FooterWrapper>
			<FooterFirstFooter>
				<FooterContentWrapper>
					<Logo onClick={() => navigate('/')}>
						fatcatarena
					</Logo>
				</FooterContentWrapper>
				{renderFooterLinks(links)}
				{/* <FooterBeforeFooter> */}
				{/*	<FooterBeforeFooterTitle> */}
				{/*		Follow Us */}
				{/*	</FooterBeforeFooterTitle> */}
				{/*	<SocialMediaWrapper> */}
				{/*	</SocialMediaWrapper> */}
				{/* </FooterBeforeFooter> */}
				<FooterContentWrapper>
					<FooterBeforeFooterTitle>
						Follow Us
					</FooterBeforeFooterTitle>
					<Flex justify="center">
						<SocialMediaIconWrapper>
							<FooterSocialMediaLinkWrapper target="_blank" href="https://www.facebook.com/fatcatremote/" rel="noreferrer">
								<SocialMedia src={Facebook} alt="Facebook logo" />
							</FooterSocialMediaLinkWrapper>
						</SocialMediaIconWrapper>
						<SocialMediaIconWrapper>
							<FooterSocialMediaLinkWrapper target="_blank" href="https://www.instagram.com/fatcat.remote/" rel="noreferrer">
								<SocialMedia src={Instagram} alt="Instagram logo" />
							</FooterSocialMediaLinkWrapper>
						</SocialMediaIconWrapper>
						<SocialMediaIconWrapper>
							<FooterSocialMediaLinkWrapper target="_blank" href="https://www.linkedin.com/company/fatcatremote/" rel="noreferrer">
								<SocialMedia src={LinkedIn} alt="Linkedin logo" />
							</FooterSocialMediaLinkWrapper>
						</SocialMediaIconWrapper>
					</Flex>
				</FooterContentWrapper>
			</FooterFirstFooter>
			<FooterSecondFooter>
				<FooterCopyright>
					{`\u00a9 ${new Date().getFullYear()} FatCatArena. All rights reserved. Made by `}
					<a href="https://fatcatremote.com">fatcatremote.com</a>
				</FooterCopyright>
			</FooterSecondFooter>
		</FooterWrapper>
	);
};

Footer.propTypes = {
	links: PropType.arrayOf(PropType.shape({})).isRequired,
};

export default Footer;
